export const actions = {
  openDialog({ commit }) {
    commit('SET_DIALOG_STATE', true);
  },
  dialogLoading({ commit }) {
    commit('SET_DIALOG_LOADING', true);
  },
};
